import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Dialog } from "@natera/platform/lib/components/dialog";
import { Button } from "@natera/form";
import "./factorList.scss";

const messages = defineMessages({
  factorDisableMessageTitle: {
    id: "factorDisableMessageTitle",
    defaultMessage: "Turn off two-factor authentication?",
  },
  factorDisableMessage: {
    id: "factorDisableMessage",
    defaultMessage:
      "Two-factor authentication adds extra protection to your account.",
  },
  factorDisableSubmitButton: {
    id: "factorDisableSubmitButton",
    defaultMessage: "Turn Off",
  },
});

interface FactorDisableDialogProps {
  onClose: () => void;
  onSubmit: () => void;
}

const FactorDisableModal: FC<FactorDisableDialogProps> = ({
  onClose,
  onSubmit,
}) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage(messages.factorDisableMessageTitle)}
      className="factor-disable-modal"
      actions={
        <div className="factor-disable-modal__buttons">
          <Button unelevated onClick={onSubmit}>
            {intl.formatMessage(messages.factorDisableSubmitButton)}
          </Button>
        </div>
      }
      onClose={onClose}
      showCrossButton
    >
      <span className="factor-disable-modal__text">
        {intl.formatMessage(messages.factorDisableMessage)}
      </span>
    </Dialog>
  );
};

export default FactorDisableModal;
